import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Grain from './components/Grain';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import About from './components/About';
import Events from './components/Events';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Grain />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Events />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
